<template>
  <v-navigation-drawer right temporary fixed app v-model="store.home.categories.show">
    <v-list>
      <template v-for="item in store.home.categories.items">
        <v-list-tile @click="item.selected = !item.selected">
          <v-list-tile-action>
            <v-icon>{{ item.selected ? 'check_box' : 'check_box_outline_blank' }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.name"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import store from '@/store'
import epromo from '@/services/epromo'
import { filter } from 'lodash'

export default {
  name: 'category-list',
  data () {
    return {
      store
    }
  },
  methods: {
    filterCategories () {
      let params = ''
      const promotions = this.store.home.promotions
      const selected = filter(this.store.home.categories.items, ['selected', true])

      for (let c in selected) {
        params = params + '&categories[]=' + selected[c].slug
      }

      promotions.status = 'loading'
      epromo.get(`/api/v2/promotions?c=c${params}`)
        .then(response => {
          promotions.items = response.data.data
          promotions.status = 'loaded'
        })
    }
  },
  watch: {
    'store.home.categories.items': {
      handler(newVal, oldVal) {
        if (oldVal.length > 0)
          this.filterCategories()// debounce(this.filterCategories(), 500)
      },
      deep: true
    }
  },
  mounted () {
    epromo.get('/api/v2/promotions/categories?perPage=50')
      .then(response => {
        this.store.home.categories.items = response.data.data.map(item => {
          item.selected = false
          return item
        })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promotions/CategoryList.vue